import {iposRoutes} from "../../../../routes/RoutesMap";

export const INDEX_PATH: string = iposRoutes.INDEX.createLink();
export const B2B_FTTB_FLOW_PATH: string = iposRoutes.B2B_FTTB_FLOW.createLink();
export const B2B_FTTB_FLOW_ADDRESS_PATH: string = iposRoutes.B2B_FTTB_FLOW_ADDRESS.createLink();
export const B2B_FTTB_FLOW_SEARCH_COMPANY_PATH: string = iposRoutes.B2B_FTTB_FLOW_SEARCH_COMPANY.createLink();
export const B2B_FTTB_FLOW_PLAN_PATH: string = iposRoutes.B2B_FTTB_FLOW_PLAN.createLink();
export const B2B_FTTB_FLOW_BILLING_ACCOUNT_PATH: string = iposRoutes.B2B_FTTB_FLOW_BILLING_ACCOUNT.createLink();
export const B2B_FTTB_FLOW_SUMMARY_PATH: string = iposRoutes.B2B_FTTB_FLOW_SUMMARY.createLink();